module.exports = __webpack_public_path__ + "static/red_dragon-de5b678062848bf77a02c1f495e51954.jpg";